import { useEffect } from "react";

interface Props {
  shouldBlock: boolean;
}

export const useBeforeUnload = ({ shouldBlock }: Props) => {
  useEffect(() => {
    if (!shouldBlock) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [shouldBlock]);
};
